module.exports = {
      id: "angle-right-usage",
      viewBox: "0 0 192 512",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#angle-right",
      toString: function () {
        return this.url;
      }
    }